import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { MenuItemsRequestCreate } from '../../../../models/api-store/menu-items/menu-items.request.model';
import { MenuItemsService } from '../../../../services/api-store/menu-items/menu-items.service';
import { UtilsService } from '../../../../services/utils-folder/utils.service';
import { TRUE } from '../../../../utils/config/const';

@Component({
  selector: 'app-footer-entity-items-create',
  templateUrl: './footer-entity-items-create.component.html'
})
export class FooterEntityItemsCreateComponent implements OnInit {

  @Input() public menuId:number;
  @Input() public lastIndex:any;
  formBuilder: FormGroup;
  request:any = {};
  ckeConfig: any;
  ckValue: string;
  @ViewChild("ckeditor") ckeditor: any;
  isButtonSaveDisabled:boolean;
  newIndex:number;

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private menuItemsService: MenuItemsService,
    private toastr: ToastrService,
    private utilsService: UtilsService
  ) { 
    this.ckeConfig = this.utilsService.configCkeditor;
    this.ckValue = '';
  }

  ngOnInit(): void {
    this.newIndex = 0;
    if(this.lastIndex!= null && typeof this.lastIndex != typeof undefined ){
      if(!isNaN(this.lastIndex)){
        this.newIndex = parseInt(this.lastIndex)+1;
      }
    }
    this.initForm();
  }

  get form(){return this.formBuilder;}
  get formControls() { return this.formBuilder.controls; }

  initForm(){
    this.formBuilder = this.fb.group({
      title: ['',[Validators.required]],
      listTitle: ['',[Validators.required]],
      index: [this.newIndex,[Validators.required]],
      externalLink: [''],
      boxSize:[4,[Validators.required,Validators.max(12), Validators.min(1)]],
      expirationDate:[null],
      content: ['']
    });
    this.isButtonSaveDisabled = false;
  }

  getValue(){
    let request = new MenuItemsRequestCreate();
    request.title = this.formBuilder.controls['title'].value;
    request.listTitle = this.formBuilder.controls['listTitle'].value;
    request.index = this.formBuilder.controls['index'].value;
    request.externalLink = this.formBuilder.controls['externalLink'].value;
    request.boxSize = this.formBuilder.controls['boxSize'].value;
    request.content = this.ckValue;
    request.expirationDate = null;
    request.menuId = this.menuId;
    return request;
  }

  save(){
    this.request = this. getValue();
    this.menuItemsService.create(this.request).subscribe(
      (response) => {
        if(response){
          //Salvato
          this.toastr.success('MenÃ¹ item creato con successo', 'Crea menÃ¹ item');
          this.isButtonSaveDisabled = true;
          this.activeModal.close(response);
        }
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.isButtonSaveDisabled = true;
        this.toastr.error('Si è verificato un errore durante la creazione del menÃ¹ item' , 'Crea menÃ¹ item fallita', {
            timeOut: 5000
        });
      }
    );
  }

  clickButtonSave(){
    if(this.formBuilder.status === 'VALID' && this.formBuilder.touched == TRUE){
      this.isButtonSaveDisabled = true;
      this.save();
    }
  }

  clickButtonCancel() {
    this.activeModal.close('CLOSE');
  }

  change() {
    this.form.markAsTouched();
  }
}
